import {
	API_ADMIN_PATCH_SAMPLE_TYPE,
	API_ADMIN_POST_SAMPLE_TYPE,
	RESET_SAMPLE_TYPE,
	API_ADMIN_DELETE_SAMPLE_TYPE,
	API_ADMIN_GET_ALL_SAMPLE_TYPE,
	API_ADMIN_GET_SAMPLE_TYPE,
	ADMIN_INIT_NEW_SAMPLE_TYPE,
	ADMIN_RESET_FOCUS_SAMPLE_TYPE,
	SET_SAMPLE_TYPE,
} from 'actions/sampleType';

export function adminGetAllSampleTypes() {
	return {
		type: API_ADMIN_GET_ALL_SAMPLE_TYPE,
		payload: {
			request: {
				url: `/admin/sampleTypes`,
			},
		},
	};
}

export function adminGetSampleTypeById(patientId) {
	return {
		type: API_ADMIN_GET_SAMPLE_TYPE,
		payload: {
			request: {
				url: `/admin/sampleTypes/${patientId}`,
			},
		},
	};
}

export function adminPatchSampleType(patient) {
	return {
		type: API_ADMIN_PATCH_SAMPLE_TYPE,
		payload: {
			request: {
				url: `/admin/sampleTypes/${patient.id}`,
				method: 'PATCH',
				data: patient,
			},
		},
	};
}

export function adminPostSampleType(patient) {
	return {
		type: API_ADMIN_POST_SAMPLE_TYPE,
		payload: {
			request: {
				url: `/admin/sampleTypes`,
				method: 'POST',
				data: patient,
			},
		},
	};
}

export function adminDeleteSampleType(patientId) {
	return {
		type: API_ADMIN_DELETE_SAMPLE_TYPE,
		payload: {
			request: {
				url: `/admin/sampleTypes/${patientId}`,
				method: 'delete',
			},
		},
	};
}

export function resetSampleType() {
	return {
		type: RESET_SAMPLE_TYPE,
		payload: null,
	};
}

export function setSampleType(sampleType) {
	return {
		type: SET_SAMPLE_TYPE,
		payload: sampleType,
	};
}

export function initNewSampleType() {
	return {
		type: ADMIN_INIT_NEW_SAMPLE_TYPE,
	};
}

export function resetFocusSampleType() {
	return {
		type: ADMIN_RESET_FOCUS_SAMPLE_TYPE,
	};
}
